module.exports = __webpack_public_path__ + "static/media/banner.e72eaed1.png";